// src/components/shared/HeaderAvatar.js
// Top-right avatar, present on every main tab screen. Always goes to
// /profile — that page itself handles signed-in vs signed-out display,
// so this never needs to gate on auth state.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';

export const HeaderAvatar = () => {
  const navigate = useNavigate();
  const { user, profile } = useAuth();

  return (
    <button
      style={styles.avatar}
      onClick={() => navigate('/profile')}
      aria-label={user ? `Profile: ${profile?.displayName || 'Your profile'}` : 'Sign in or view profile'}
    >
      {user ? (
        profile?.photoUrl
          ? <img src={profile.photoUrl} alt="" style={styles.photo} />
          : (profile?.displayName?.[0] || 'G')
      ) : '👤'}
    </button>
  );
};

const styles = {
  avatar: {
    width: 40, height: 40, background: 'var(--sage)', borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: 'var(--sage-dark)', fontSize: 15, fontWeight: 800,
    cursor: 'pointer', flexShrink: 0, border: '2px solid rgba(255,255,255,0.6)',
    minHeight: 40, minWidth: 40, overflow: 'hidden',
  },
  photo: { width: '100%', height: '100%', objectFit: 'cover' },
};

export default HeaderAvatar;
